export default "__VITE_ASSET__dd00b5b5__"